import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { DateTime } from 'luxon';
import { transformCivilStatus } from 'shell/utils/consult-person/response-transformer/marital-status/civil-status';
import { CancelMarriageFormVM } from 'mutation/view-models/cancel-marriage';
import { CivilStatusID } from 'shell/constants/civil-status';
import { ActType } from 'shell/constants/act-type';
import { transformMarriageActAnpr05 } from 'shell/utils/consult-person/response-transformer/marital-status/marriage-act-anpr05';
import { emptyDigital, emptyPaper } from 'shell/components/shared/act/constants';
import { transformCitizenship } from 'shell/utils/consult-person/response-transformer/registry-office/citizenship';
import { transformFamilyCoexistence } from 'shell/utils/consult-person/response-transformer/family/family-coexistence';

export const checkPersonCancelMarriage = (civilStatus: string | undefined): boolean => {
  if (civilStatus && civilStatus !== CivilStatusID.coniugato) {
    return false;
  }

  return true;
};

export const transformerCancelMarriageData = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): CancelMarriageFormVM => {
  const [person] = response.data?.payload?.risposta3002OK?.listaSoggetti.datiSoggetto || [];

  const personData = transformPerson(person);
  const citizenship = transformCitizenship(person);
  const familyCoexistence = transformFamilyCoexistence(person);

  const civilStatus = transformCivilStatus(person);

  const marriage = transformMarriageActAnpr05(person);

  const result: CancelMarriageFormVM = {
    person: personData,
    citizenship,
    familyCoexistence,
    civilStatus: {
      ...(civilStatus || {}),
      oldStatus: civilStatus?.status,
      status: CivilStatusID.divorziato,
    },
    editDataControl: {
      dateValidity: DateTime.now(),
    },
    marriage,
    cancelMarriage: {
      type: '',
      dateJudgment: null,
      dateValidity: null,
      authority: '',
      courtType: '',
      municipality: null,
      foreignMunicipality: null,
      actType: ActType.AttoCartaceo,
      paper: emptyPaper,
      digital: emptyDigital,
    },
  };

  return result;
};
